
import React, { useState } from "react";
import {
    useQuery,
} from "react-admin";
import { Grid } from '@material-ui/core';
import {
    SimpleForm, TextInput, SelectInput, DateInput, NumberInput,
    BooleanInput,
    ArrayInput,
    SimpleFormIterator,
    FormDataConsumer,
    useMutation,
    useNotify,
} from 'react-admin';


import { List, Datagrid, TextField, EditButton } from 'react-admin';

import { DateField, Pagination } from '../../partials';
import { USER_GROUP_ADMIN } from '../../utils/const';

const ButtonEdit = ({ onRedirect, ...props }) => {
    if (props.permissions !== USER_GROUP_ADMIN && props.record && props.record.config_group === "app_version") return ""
    return (
        <EditButton {...{
            ...props,
            ...(onRedirect && typeof onRedirect === "function" ? { onClick: (e) => onRedirect(e, props.record) } : {})
        }} />
    )
}
const CoefficientComponent = (props) => {
    const { record = {} } = props;
    if (record.config_group !== "point") return ""
    return (
        <TextField record={record} source="coefficient" label="Coefficient" />
    );
}
const DatagridComponent = ({ onRedirect, ...props }) => {
    return (
        <Datagrid {...props}>
            <TextField source="config_group" label="Group" />
            <TextField source="config_key" label="Key" />
            <CoefficientComponent source="coefficient" label="Coefficient" />
            <TextField source="config_value" label="Value" />
            <TextField source="description" label="Description" />
            <DateField source="created_at" label="Created" />
            <ButtonEdit onRedirect={onRedirect} />
        </Datagrid>
    )
};

const AgencySchedule = () => {
    const notify = useNotify();
    const [agencyInfo, setAgencyInfo] = useState();
    const { loading, error } = useQuery(
        {
            type: "currentAgency",
            resource: "agencies",
        },
        {
            onSuccess: ({ data = {} }) => {
                setAgencyInfo(data);
            },
        }
    );

    const [updateAgencySchedules] = useMutation(
        {
            type: "updateAgencySchedules",
            resource: "agencies",
            payload: agencyInfo,
        },
        {
            onSuccess: ({ data, status, message }) => {
                if (status) {
                    notify("Updated agency schedules successfully", "info");
                } else {
                    notify(`Update agency schedules error: ${message}`, "warning");
                }
            },
            onFailure: (error) =>
                notify(`Update agency schedules error: ${error.message}`, "warning"),

        }
    );


    /*
     {"sunday":[{"open":21600,"close":64800},{"open":21600,"close":64800}],"monday":[{"open":21600,"close":64800}],"tuesday":[{"open":21600,"close":64800}],"wednesday":[{"open":21600,"close":64800}],"thursday":[{"open":21600,"close":64800}],"friday":[{"open":21600,"close":64800}],"saturday":[{"open":21600,"close":64800}]}
     */

    const formatTime = (seconds) => {
        if (!seconds && seconds !== 0) return '';
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
    };

    const parseTime = (timeString) => {
        if (!timeString) return 0;
        const [hours, minutes] = timeString.split(':').map(Number);
        return hours * 3600 + minutes * 60;
    };

    const weekdays = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

    const onSubmit = async (values) => {
        setAgencyInfo(values);
        updateAgencySchedules({ payload: values });
    }

    return (
        <div style={{ marginBottom: 10 }}>
            <h3>Agency Schedule</h3>
            {loading && <p>Loading...</p>}
            {error && <p>Error: {error.message}</p>}
            {agencyInfo && (
                <div>
                    <p>Name: {agencyInfo.name}</p>
                    <SimpleForm initialValues={agencyInfo} save={onSubmit}>
                        <Grid md={12} container fullWidth spacing={3}>
                            <Grid item md={12}>
                                <BooleanInput label="Deny Order Out Of Working Time" source="deny_order_out_of_working_time" />
                            </Grid>

                            {weekdays.map((day) => {
                                return (
                                    <Grid item md={6} key={day}>
                                        <h4 style={{ textTransform: 'capitalize', marginBottom: '10px' }}>{day}</h4>
                                        <ArrayInput source={"schedules." + day} label={""}>
                                            <SimpleFormIterator inline>
                                                <FormDataConsumer>
                                                    {(props) => {
                                                        return (
                                                            <>
                                                                <Grid container md={12} spacing={2} fullWidth>
                                                                    <Grid item xs={5}>
                                                                        <TextInput
                                                                            label={`Open Time`}
                                                                            source={props.getSource("open")}
                                                                            format={formatTime}
                                                                            parse={parseTime}
                                                                            type="time"
                                                                            fullWidth
                                                                        />
                                                                    </Grid>
                                                                    <Grid item xs={5}>
                                                                        <TextInput
                                                                            label={`Close Time`}
                                                                            source={props.getSource("close")}
                                                                            format={formatTime}
                                                                            parse={parseTime}
                                                                            type="time"
                                                                            fullWidth
                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                            </>
                                                        );
                                                    }}
                                                </FormDataConsumer>
                                            </SimpleFormIterator>
                                        </ArrayInput>
                                    </Grid>
                                );
                            })}

                            {weekdays.map((day) => {
                                return (<></>);
                                const daySchedules = (agencyInfo.schedules && agencyInfo.schedules[day]) || [];
                                return (
                                    <Grid item md={3} key={day}>
                                        <h4 style={{ textTransform: 'capitalize', marginBottom: '10px' }}>{day}</h4>
                                        {daySchedules.map((_, timeSlotIndex) => (
                                            <Grid item md={12} key={`${day}-${timeSlotIndex}`}>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={5}>
                                                        <TextInput
                                                            label={`Open Time ${timeSlotIndex + 1}`}
                                                            source={`schedules.${day}[${timeSlotIndex}].open`}
                                                            format={formatTime}
                                                            parse={parseTime}
                                                            type="time"
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item xs={5}>
                                                        <TextInput
                                                            label={`Close Time ${timeSlotIndex + 1}`}
                                                            source={`schedules.${day}[${timeSlotIndex}].close`}
                                                            format={formatTime}
                                                            parse={parseTime}
                                                            type="time"
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item xs={2} >
                                                        <button
                                                            type="button"
                                                            style={{
                                                                padding: '5px',
                                                                background: '#f0f0f0',
                                                                border: '1px solid #ddd',
                                                                borderRadius: '4px',
                                                                cursor: 'pointer',
                                                                color: '#f44336'
                                                            }}
                                                            onClick={() => {
                                                                const updatedSchedules = { ...agencyInfo.schedules };
                                                                if (updatedSchedules[day]) {
                                                                    updatedSchedules[day] = updatedSchedules[day].filter((_, idx) => idx !== timeSlotIndex);
                                                                    setAgencyInfo({ ...agencyInfo, schedules: updatedSchedules });
                                                                }
                                                            }}
                                                        // disabled={daySchedules.length <= 1}
                                                        >
                                                            ✕
                                                        </button>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        ))}
                                        <button
                                            type="button"
                                            style={{
                                                marginTop: '10px',
                                                padding: '5px 10px',
                                                background: '#f0f0f0',
                                                border: '1px solid #ddd',
                                                borderRadius: '4px',
                                                cursor: 'pointer'
                                            }}
                                            onClick={() => {
                                                const updatedSchedules = { ...agencyInfo.schedules };
                                                if (!updatedSchedules[day]) {
                                                    updatedSchedules[day] = [];
                                                }
                                                updatedSchedules[day] = [
                                                    ...updatedSchedules[day],
                                                    { open: 0, close: 0 }
                                                ];
                                                setAgencyInfo({ ...agencyInfo, schedules: updatedSchedules });
                                            }}
                                        >
                                            + Add time slot
                                        </button>
                                    </Grid>
                                );
                            })}
                        </Grid>
                    </SimpleForm>
                </div>
            )
            }
        </div >
    );
}

const ListComponent = ({ onRedirect, ...props }) => {

    return (
        <>
            <AgencySchedule />
            <List {...props} pagination={<Pagination />} perPage={20} bulkActionButtons={false} sort={{ field: 'created_at', order: 'DESC' }}>
                <DatagridComponent onRedirect={onRedirect} {...props} />
            </List>
        </>
    )
};

export default ListComponent
export { DatagridComponent }
